<div class="smt-search-filter-menu-card">
    <div class="smt-search-filter-title">
        <ng-content select="filter-title"></ng-content>
        <mat-icon class="smt-search-filter-title-action"
                  (click)="onClose()"
                  [matTooltip]="'SEARCH.FILTER.BUTTONS.CLOSE' | translate">
            close
        </mat-icon>
    </div>

    <div class="smt-search-filter-content">
        <ng-content select="filter-content"></ng-content>
    </div>

    <div *ngIf="showActions" class="smt-search-filter-actions">
        <ng-content select="filter-actions"></ng-content>
    </div>
</div>